import { render, staticRenderFns } from "./AuthView_ResetPassword.vue?vue&type=template&id=a83a81d8&"
import script from "./AuthView_ResetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthView_ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports